import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const ProductDetailsAccordionsLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <Wrapper className={className} style={style}>
      <SkeletonBlock $width="100%" $height="60px" />
      <SkeletonBlock $width="100%" $height="60px" />
      <SkeletonBlock $width="100%" $height="60px" />
      <SkeletonBlock $width="100%" $height="60px" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
